<template>
  <b-modal
    id="docForm"
    title="Вид"
    centered
    no-close-on-backdrop
    cancel-title="Отмена"
    ok-title="Сохранить"
    @show="openShowModal"
    @ok.prevent="onSubmit"
  >
    <validation-observer ref="validation">
      <b-form-group label="Наименование">
        <validation-provider
          #default="{ errors }"
          name="Наименование"
          rules="required"
        >
          <b-form-input v-model="val.title" />
          <small class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <b-form-group label="Статус">
        <b-form-checkbox
          v-model="val.status"
          name="check-button"
          switch
          :checked="true"
          inline
        >
          <span class="switch-icon-left">
            <feather-icon icon="CheckIcon" />
          </span>
          <span class="switch-icon-right">
            <feather-icon icon="XIcon" />
          </span>
        </b-form-checkbox>
      </b-form-group>
    </validation-observer>
  </b-modal>
</template>

<script>
import {
  BModal, BFormGroup, BFormInput, BFormCheckbox,
} from 'bootstrap-vue'
import { mapActions } from 'vuex'

export default {
  components: {
    BFormCheckbox,
    BModal,
    BFormGroup,
    BFormInput,
  },
  props: {
    modalValue: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      val: {
        title: null,
        status: true,
      },
    }
  },
  methods: {
    ...mapActions('reference', ['ADD_EDO_DOC', 'UPDATE_EDO_DOC']),

    onSubmit() {
      this.$refs.validation.validate().then(success => {
        if (success) {
          const updateFile = this.modalValue?.id
            ? this.UPDATE_EDO_DOC({
              id: this.modalValue.id,
              ...this.val,
            })
            : this.ADD_EDO_DOC(this.val)

          updateFile.then(() => {
            this.$bvModal.hide('docForm')
            this.$emit('refresh')
            this.$_okToast()
          }).catch(e => this.$_errorToast(e))
        }
      })
    },

    openShowModal() {
      if (this.modalValue.id) {
        this.val = JSON.parse(JSON.stringify(this.modalValue))
      } else {
        this.val = {
          title: null,
          status: true,
        }
      }
    },
  },
}
</script>
